module.exports = __webpack_public_path__ + "static/media/jiesuanicon.d67b10d1.png";